import React, { useState, Suspense } from "react";
import { Maximize2, X } from "lucide-react";

const GoogleMaps = React.lazy(() =>
  import("../../modules/TrackingControls/TrackingControlsUpdate")
);

const TrackingPageLite = ({ isExpanded = false, onExpand, onClose }) => {
  const [primaryChecked, setPrimaryChecked] = useState(false);
  const [analyticsPeriod, setAnalyticsPeriod] = useState(null);

  // Si expandu, on affiche en plein écran
  if (isExpanded) {
    return (
      <div className="fixed inset-0 z-[150] bg-background">
        <div className="h-full flex flex-col">
          <div className="flex items-center justify-between border-b border-border bg-card px-4 py-3">
            <h3 className="text-lg font-semibold text-foreground">
              Suivi en Temps Réel
            </h3>
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-border p-2 text-muted-foreground hover:bg-secondary/60 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="flex-1 overflow-hidden">
            <Suspense fallback={
              <div className="h-full w-full flex items-center justify-center text-sm text-muted-foreground">
                Chargement de la carte...
              </div>
            }>
              <GoogleMaps
                primaryChecked={primaryChecked}
                analyticsPeriod={analyticsPeriod}
                alertsList={<div />}
                periodSelector={<div />}
              />
            </Suspense>
          </div>
        </div>
      </div>
    );
  }

  // Version compressée
  return (
    <div className="rounded-2xl bg-card border border-border shadow-sm p-4 h-full flex flex-col">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-base md:text-lg font-semibold text-foreground tracking-tight">
          Suivi en Temps Réel de la flotte
        </h3>
        <button
          type="button"
          className="p-1.5 rounded hover:bg-secondary"
          onClick={onExpand}
        >
          <Maximize2 className="w-4 h-4 text-muted-foreground" />
        </button>
      </div>

      <div className="flex-1 min-h-0 rounded-xl border border-border bg-secondary/20 overflow-hidden relative">
        <Suspense fallback={
          <div className="h-full w-full flex items-center justify-center text-sm text-muted-foreground">
            Chargement de la carte...
          </div>
        }>
          <GoogleMaps
            primaryChecked={primaryChecked}
            analyticsPeriod={analyticsPeriod}
            alertsList={<div />}
            periodSelector={<div />}
          />
        </Suspense>
      </div>
      
    </div>
  );
};

export default TrackingPageLite;
